import { useQuery } from '@tanstack/react-query'

import { useAuthInfo } from '@sweetauth/core'

import { API_URL } from '@/constants/env'

import type { OpportunityType } from '@/types/Opportunity'

const triggerOpportunityIndex = async (
  opportunityId: string,
  opportunityType: OpportunityType,
  accessToken: string | undefined | null,
): Promise<null> => {
  if (accessToken === null || accessToken === undefined) {
    throw new Error('No access token provided.')
  }
  const res: Response = await fetch(`${API_URL}/api/v1/index-opportunity/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      opportunity_id: opportunityId,
      opportunity_type: opportunityType,
    }),
  })
  if (!res.ok) {
    throw new Error(res.statusText)
  }
  return null
}

export const useIndexOpportunity = (
  opportunityId: string,
  opportunityType: OpportunityType,
) => {
  const { accessToken, isLoggedIn, user } = useAuthInfo()
  return useQuery({
    queryFn: () =>
      triggerOpportunityIndex(opportunityId, opportunityType, accessToken),
    queryKey: [
      user?.userId,
      opportunityId,
      opportunityType,
      'indexOpportunity',
    ],
    staleTime: Infinity,
    enabled: !!isLoggedIn,
  })
}
